@if (initialized && formGroup) {

  <div class="grid" [formGroup]="formGroup">

<!--    <div class="mx-auto p-2">-->
<!--      <div class="text-center mb-3">-->
<!--        <div class="text-900 text-3xl font-semibold">Persönliche Daten ändern</div>-->
<!--      </div>-->
<!--    </div>-->


    <!--    <div class="flex flex-column align-items-center flex-or w-full mb-5">-->
    <!--      <span class="text-color mb-2 text-sm">Profilbild</span>-->
    <!--      <div  class="h-7rem w-7rem border-1 border-300 border-circle">-->
    <!--        <i *ngIf="!imageSrc" class="pi pi-user flex justify-content-center align-items-center text-3xl h-full text-400"></i>-->
    <!--        <img [src]="imageSrc" class="h-7rem w-7rem border-1 border-300 border-circle cursor-pointer" (click)="displayDialog = true"/>-->
    <!--      </div>-->
    <!--      <input id="upload" type="file" class="none" hidden accept="image/*" (change)="onUploadHandler($event)" *ngIf="!imageSrc" />-->
    <!--      <label for="upload" class="p-element p-button-rounded surface-500 w-2rem h-2rem -mt-4 p-button p-component p-button-icon-only border-none" *ngIf="!imageSrc">-->
    <!--        <span  class="p-button-icon text-sm pi pi-upload" aria-hidden="true"></span>-->
    <!--      </label>-->
    <!--      <label for="delete" class="p-element p-button-rounded surface-500 w-2rem h-2rem -mt-4 p-button p-component p-button-icon-only border-none" *ngIf="imageSrc">-->
    <!--        <span id="delete" (click)="handleDeleteImage()" class="p-button-icon text-sm pi pi-trash"></span>-->
    <!--      </label>-->
    <!--    </div>-->

    <div class="flex flex-column align-items-center flex-or w-full mb-5">
<!--      <span class="text-color mb-2 text-sm">Profilbild</span>-->
      <div class="h-7rem w-7rem border-circle">
        <!--        <i *ngIf="!imageSrc" class="pi pi-user flex justify-content-center align-items-center text-3xl h-full text-400"></i>-->
        <img [src]="imageSrc ?? 'assets/images/blank_user.png'" class="h-7rem w-7rem border-circle"/>
        <!--        <img *ngIf="imageSrc"  class="h-7rem w-7rem border-circle" [src]="imageSrc"/>-->
      </div>
      <input id="upload" type="file" class="none" hidden accept="image/*" (change)="onUploadHandler($event)"
             *ngIf="!imageSrc"/>
      <label for="upload"
             class="p-element p-button-rounded p-button-text surface-500 w-2rem h-2rem -mt-3 p-button p-component p-button-icon-only"
             *ngIf="!imageSrc">
        <span class="p-button-icon text-sm pi pi-upload text-white" aria-hidden="true"></span>
      </label>
      <label for="delete"
             class="p-element p-button-rounded p-button-text  surface-500 w-2rem h-2rem -mt-3 p-button p-component p-button-icon-only"
             *ngIf="imageSrc">
        <span id="delete" (click)="handleDeleteImage()" class="p-button-icon text-sm pi pi-trash text-white"></span>
      </label>
    </div>


    <div class="col-12">
      <div class="grid formgrid p-fluid">
        <div class="field xl:col-6 col-12">
          <label for="firstName" class="font-medium text-900">Vorname</label>
          <span class="p-input-icon-left">
                <i class="pi pi-user"></i>
              <input id="firstName" formControlName="firstName" type="text" pInputText>
          </span>
        </div>

        <div class="field xl:col-6 col-12">
          <label for="lastName" class="font-medium text-900">Nachname</label>
          <span class="p-input-icon-left">
                <i class="pi pi-user"></i>
              <input id="lastName" formControlName="lastName" type="text" pInputText>
              </span>
        </div>

        <div class="field xl:col-6 col-12">
          <label for="address" class="font-medium text-900">Adresse</label>
          <span class="p-input-icon-left">
                <i class="pi pi-id-card"></i>
              <input id="address" formControlName="address" type="text" pInputText>
              </span>
        </div>

        <div class="field xl:col-6 col-12">
          <label for="uiBirthDate" class="font-medium text-900">Geburtsdatum</label>
          <span class="p-input-icon-left">
                <i class="pi pi-gift"></i>
              <input id="uiBirthDate" formControlName="uiBirthDate" type="text" pInputText>
              </span>
        </div>

      </div>
    </div>

    <div class="field xl:col-6 col-12 flex flex-column">
      <label for="email" class="font-medium text-900">Email</label>
      <span class="p-input-icon-right">
                <i class="pi pi-pencil cursor-pointer" (click)="handleEditEmail()"></i>
              <input class="w-full cursor-grab" readonly id="email" formControlName="email" type="text" pInputText>
          </span>
    </div>

    <div class="field xl:col-6 col-12">
      <label for="phone" class="font-medium text-900">Mobilnummer</label>
      <span class="p-input-icon-right p-input-icon-left  block">
            <i class="flex gap-2 text-primary line-height-1 font-medium" style="font-style: normal;">
              <div class="flag-container">
              <div class="stripe black"></div>
              <div class="stripe red"></div>
              <div class="stripe gold"></div>
              </div>+49</i>
        <i class="pi pi-pencil cursor-pointer" (click)="handleEditPhone()"></i>
                  <input [style]="{'padding-left': '6rem', width: '100%'}" pInputText id="phone"
                         readonly
                         minlength="8" formControlName="phoneNumber"/>
      </span>
    </div>


  </div>

  <p-dialog
    header="Bild anpassen"
    [(visible)]="showImageCropperDialog"
    [modal]="true"
    [style]="{width: '50rem', height: '50rem'}"
    (onHide)="resetFileInput()"
  >
    <ng-template pTemplate="content">
      <div class="flex align-items-center h-full">
        <image-cropper
          *ngIf="imageChangedEvent"
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1/1"
          format="png"
          (imageCropped)="imageCropped($event)">
        </image-cropper>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button type="button" pButton label="Übernehmen" icon="pi pi-check" (click)="uploadCroppedImage()"></button>
    </ng-template>
  </p-dialog>


}
